export const axiosConciseErrorInterceptor = (err) => {
    let msg = 'Unknown error';
    const url = err.config?.url || 'Unknown URL';
    if (err.response) {
        // Get first 200 characters from the response data
        try {
            const dataSnippet = JSON.stringify(err.response.data).slice(0, 200);
            msg = `[Error] URL: ${url} - Status: ${err.response.status} - Data: ${dataSnippet}`;
        }
        catch {
            msg = `[Error] URL: ${url} - Status: ${err.response.status} - Data: failed to deserialize error data`;
        }
    }
    else if (err.request) {
        msg = `[Error] URL: ${url} - No response from server`;
    }
    else {
        msg = `[Error] URL: ${url} - Setup issue: ${err.message}`;
    }
    return Promise.reject(new Error(msg));
};
//# sourceMappingURL=axios.js.map